module.exports = __webpack_public_path__ + "static/media/Benchmark.def495a4.jpg";